import { z } from 'zod';

export const errorResponseSchema = z.object({
  error: z.string(),
  message: z.string(),
  details: z.unknown().optional(),
});
export type ErrorResponse = z.infer<typeof errorResponseSchema>;

export const okResponseSchema = z.object({ ok: z.literal(true) });

/** Header obligatorio en toda mutación (defensa CSRF junto con Origin + SameSite=Lax). */
export const CSRF_HEADER = 'x-requested-with';
export const CSRF_HEADER_VALUE = 'platform-web';

export const healthResponseSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  checks: z.record(z.string(), z.enum(['ok', 'fail'])).optional(),
});
